<template>
  <div>
    <img class="spinner" src="~@/images/spinner.png" alt="" aria-hidden="true">
  </div>
</template>

<script>

export default {
  name: 'spinner',
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus" src="./spinner.styl" >



// WEBPACK FOOTER //
// src/components/spinner/spinner.vue